/**
 * Tiny inline reminder used wherever a free-text input could tempt operators
 * to enter clinical data. Keeps liability posture explicit.
 */
import { ShieldAlert } from "lucide-react";

export default function DataDisciplineNote({ className = "" }) {
  return (
    <div
      data-testid="data-discipline-note"
      className={`flex items-start gap-2 rounded-lg border border-amber-200 bg-amber-50 px-3 py-2 text-[11px] text-amber-900 leading-relaxed ${className}`}
    >
      <ShieldAlert className="w-3.5 h-3.5 mt-[1px] shrink-0 text-amber-700" />
      <span>
        <b>Reminder:</b> Do not enter unnecessary clinical information — diagnoses, SOAP notes, treatment plans, or outcome data.
        Nodera surfaces operational metrics only.
      </span>
    </div>
  );
}
